import { Spinner, useInfiniteShadowScroll } from "@swivl-mono/ui";
import { useEffect } from "react";

import "./InfiniteScrollView.scss";

interface Props {
  children?: React.ReactNode;
  shouldLoadMore?: boolean;
  loadMore?: () => void;
  isLoadingMore?: boolean;
}

export function InfiniteScrollView(props: Props) {
  const { children, shouldLoadMore, isLoadingMore, loadMore } = props;
  const { boxShadow, onScrollHandler, isAtBottom } = useInfiniteShadowScroll(true, false);

  useEffect(() => {
    if (isAtBottom && shouldLoadMore && !isLoadingMore && loadMore) {
      loadMore();
    }
  }, [isAtBottom, shouldLoadMore, isLoadingMore]);

  return (
    <div className="InfiniteScrollView" onScroll={onScrollHandler} style={boxShadow}>
      {children}
      {isLoadingMore && (
        <div className="loadingMore">
          <Spinner />
        </div>
      )}
    </div>
  );
}
